import React from 'react';

export const InlineList: React.FC<{ children: React.ReactNode; separator?: React.ReactNode }> = ({
    children,
    separator,
}) => {
    const count = React.Children.count(children);

    if (count === 0) {
        return null;
    }

    if (count === 1) {
        const child = React.Children.only(children);

        return <>{child}</>;
    }

    return (
        <>
            {React.Children.toArray(children).reduce<Array<React.ReactNode>>(
                (prev, next, i, arr) => {
                    if (i === arr.length - 1) {
                        prev.push(next);

                        return prev;
                    }

                    if (typeof next === 'string') {
                        prev.push(next, separator);
                    }

                    if (React.isValidElement(next)) {
                        prev.push(next, separator);
                    }

                    return prev;
                },
                [],
            )}
        </>
    );
};

export const InlineBulletList: React.FC<{ children: React.ReactNode }> = ({ children }) => (
    <InlineList children={children} separator=" · " />
);
